import React from 'react';
import { connect } from 'react-redux';
import CaravansActions from '../redux/caravansRedux';
import ConfigurationActions from '../redux/configurationRedux';
import { getUrlParameter, isNil, getItemByKeyValue, has } from '../services/helper';
import CaravanConfigurationApi from '../services/apis/caravanConfiguration';
import UserInformationApi from '../services/apis/userInformation';
import ShownStepsActions from '../redux/shownStepsRedux';

// Components
import Header from './header/headerComponent';
import NavigationButtons from './navigationButtons/navigationButtonsComponent';
import Canvas from './canvas/canvasComponent';
import Footer from './footer/footerComponent';

import style from '../styles/app.scss';

class App extends React.Component {
    constructor() {
        super();
        this.state = {
            caravanIdentifier: 0,
            modelIdentifier: 0,
        };
        const url = new URLSearchParams(window.location.search.slice(1));
        const configurationCode = url.get('configurationCode');
        if (configurationCode !== '') {
            this.forceLoadConfiguration(configurationCode);
        }

        UserInformationApi.getUserInformation().then(data => {
            if (data.data.success === true) {
                this.props.setUserData(data.data.data);
            }
        });
    }

    /**
     * Checking URI parameter for caravan and model identifiers
     * When we have caravans we fetch just this caravan.
     *
     * @return {void}
     */
    getInitialCaravan = () => {
        const caravanParameter = getUrlParameter('caravan');
        const modelParameter = getUrlParameter('model');
        const caravanIdentifier = parseInt(caravanParameter, 10);
        const modelIdentifier = parseInt(modelParameter, 10);
        this.updateLocalState(caravanIdentifier, modelIdentifier);
        if (!isNaN(caravanIdentifier) && caravanIdentifier >= 0) {
            this.props.getCaravanRequest(caravanIdentifier);
        } else {
            this.props.listCaravansRequest();
        }
    }

    /**
     * Writes the predefined caravan and model identifier to the local state if the
     * values are clean.
     *
     * @return {void}
     */
    updateLocalState = (caravanIdentifier, modelIdentifier) => {
        this.setState((prevState) => {
            const newState = prevState;
            if (!isNaN(caravanIdentifier) && caravanIdentifier >= 0) {
                newState.caravanIdentifier = caravanIdentifier;
            }

            if (!isNaN(modelIdentifier) && modelIdentifier >= 0) {
                newState.modelIdentifier = modelIdentifier;
            }

            return { newState };
        });
    };

    /**
     * If we have valid presets for caravan and/or model, we need to update
     * the configuration based on that data.
     *
     * @return {void}
     */
    preselectCaravanAndModel = (caravans, configuration) => {
        const { caravanIdentifier, modelIdentifier } = this.state;
        const noCaravans = isNil(caravans);
        if (caravanIdentifier > 0 && isNil(configuration.caravan) && !noCaravans) {
            const presetCaravan = getItemByKeyValue(caravans, 'id', caravanIdentifier);
            this.props.setCaravan(presetCaravan);
            if (modelIdentifier > 0 && has(presetCaravan, 'models')) {
                this.props.setModel(getItemByKeyValue(presetCaravan.models, 'id', modelIdentifier));
            }
        }
    }

    forceLoadConfiguration = (configurationCode) => {
        if (configurationCode === '' || configurationCode === null) {
            return;
        }
        const configuration = CaravanConfigurationApi.load(configurationCode);
        configuration.configuration.then(data => {
            this.props.setCaravan(data.data.data.configuration.caravan);
            this.props.setModel(data.data.data.configuration.model);
            this.props.setConfiguration(data.data.data.configuration.configurations);
            this.props.setFormData(data.data.data.configuration.formData);
            this.props.navigateToConclusion();
        });
    };

    componentWillMount() {
        this.getInitialCaravan();
    }

    componentWillReceiveProps(nextProps) {
        const { caravans, configuration } = nextProps;
        this.preselectCaravanAndModel(caravans, configuration);
    }

    render() {
        return (
            <div>
                <div className={style.container}>
                    <Header />
                </div>
                <div className={style.canvas}>
                    <div className={style.container}>
                        <NavigationButtons />
                        <Canvas />
                    </div>
                </div>
                <div className={style.container}>
                    <Footer />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    configuration: state.configuration,
    caravans: state.caravans.caravans,
});

const mapDispatchToProps = dispatch => ({
    listCaravansRequest: () => dispatch(CaravansActions.listCaravansRequest()),
    getCaravanRequest: (identifier) => dispatch(CaravansActions.getCaravanRequest(identifier)),
    setCaravan: (caravan) => dispatch(ConfigurationActions.setCaravan(caravan)),
    setModel: (model) => dispatch(ConfigurationActions.setModel(model)),
    setConfiguration: configurations => dispatch(
        ConfigurationActions.setConfigurations(configurations)
    ),
    setFormData: formData => dispatch(
        ConfigurationActions.setFormData(formData)
    ),
    setUserData: (userData) => dispatch(
        ConfigurationActions.setUserData(userData)
    ),
    navigateToConclusion: () => {
        for (let stepId = 1; stepId < 8; stepId += 1) {
            dispatch(ShownStepsActions.addShownStep(stepId));
        }
        dispatch({
            type: 'NAVIGATE',
            step: 8,
        });
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
